/*
 *
 * SettingsLanguagePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 23-Apr-2025
*/

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import PortalRadioBox from '@nexidigital/portalradiobox'
import { useIntl } from 'react-intl'
import { flowToastMapType } from 'Utility/flowToastMap'
import formattedMessage from './languageModule'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import componentConfig from 'Utility/globalConfig'

import './SettingsLanguagePopup.scss'

const languageOptions = componentConfig.languageSelect.availableLanguages().map((language) => ({
  label: language.longExtendedLabel,
  value: language.value,
  flag: language.flag
}))

const SettingsLanguagePopup = (props) => {
  const intl = useIntl()
  const supportedLanguages = props.languages.map(({ value }) => value)
  const [language, setLanguage] = useState(() => {
    const storedLanguage = window.localStorage.getItem('userLanguage')
    if (supportedLanguages.includes(storedLanguage)) return storedLanguage

    const navigatorLang = (navigator.language || navigator.userLanguage)?.substring(0, 2)
    if (supportedLanguages.includes(navigatorLang)) return navigatorLang

    return supportedLanguages[0] || 'en'
  })
  const handleLanguageChange = (value) => {
    setLanguage(value)
  }
  const handlePrimaryAction = () => {
    window.localStorage.setItem('userLanguage', language)
    props.actions.doLanguageChange(language)
    // Show a success toast message.
    props.actions.doShowToast(flowToastMapType.SUCCESS_TOAST, {
      label: formattedMessage.languageChangedToast
    })

    props.actions.doHidePopup()
  }

  return (
    <Toggle>
      <MerchantModal
        onClose={() => props.actions.doHidePopup()}
        primaryAction={handlePrimaryAction}
        primaryButtonLabel={intl.formatMessage({ id: 't.app.confirm' })}
        title={intl.formatMessage({ id: 't.app.settings.switchLanguage.title' })}
      >
        <MerchantGenericCard title={formattedMessage.description}>
          <div className='switchLanguage'>
            <PortalRadioBox options={props.languages} defaultValue={language} onChange={handleLanguageChange} centered />
          </div>
        </MerchantGenericCard>
      </MerchantModal>
    </Toggle>
  )
}

SettingsLanguagePopup.propTypes = {
  actions: PropTypes.object.isRequired,
  languages: PropTypes.array
}

SettingsLanguagePopup.defaultProps = {
  actions: {},
  languages: languageOptions
}

export default SettingsLanguagePopup
